import React, { useState } from "react";
import styles from "../../styles/Sidebar.module.scss";
import Link from "next/link";
import { onSignOut } from "../../views/auth/fetchers/auth";
import { useRouter } from "next/router";
import { MenuItem } from "../../layout/PrimaryLayout";

interface OwnProps {
  menu: MenuItem[];
}
type Props = OwnProps;

interface Button {
  active: boolean;
  children: any;
}

const Button = (props: Button) => (
  <a
    className={styles.button + (props.active ? " " + styles.activebutton : "")}
    {...props}
  >
    {props.children}
  </a>
);

const Accordion: React.FC<{ data: any; accordion_id: string }> = ({
  data,
  accordion_id,
}) => {
  const router = useRouter();

  const shouldBeOpened = (links: any) => {
    let open: boolean = false;
    links.forEach((link) => {
      if (router.asPath.includes(link.link)) open = true;
    });
    return open;
  };

  const subShouldBeOpened = (links: any) => {
    let open: boolean = false;
    links.forEach((link) => {
      if (link.multi) {
        link.subLinks.forEach((item) => {
          if (router.asPath.includes(item.link)) open = true;
        });
      }
    });
    return open;
  };

  const [isOpened, setOpened] = useState<boolean>(shouldBeOpened(data.links));
  const [isSubOpened, setSubOpened] = useState<boolean>(
    subShouldBeOpened(data.links)
  );

  return (
    <div className={styles.accordion} key={accordion_id}>
      <div
        className={
          styles.accordiontitle +
          (isOpened ? " " + styles.accordionactivetitle : "")
        }
        onClick={() => setOpened(!isOpened)}
      >
        <div>
          <div className={styles.accordionicon}>
            <img src={"/public-new/navigation/" + data.icon + ".svg"} alt="" />
          </div>
          <div>{data.title}</div>
        </div>
        <img
          className={styles.arrow}
          src={"/public-new/arrow-down.svg"}
          alt=""
        />
      </div>
      {isOpened && (
        <div className={styles.menu}>
          {data.links.map((link, index) => (
            <React.Fragment key={`${accordion_id}-link-${index}`}>
              {link.multi ? (
                <>
                  <div
                    className={
                      styles.accordiontitle +
                      (isSubOpened ? " " + styles.accordionactivetitle : "")
                    }
                    onClick={() => setSubOpened(!isSubOpened)}
                  >
                    <div className={styles.submenutitle}> {link.title}</div>
                    <img
                      className={styles.arrow}
                      src={"/public-new/arrow-down.svg"}
                      alt=""
                    />
                  </div>
                  {isSubOpened && (
                    <div className={styles.submenu}>
                      {link.subLinks.map((link) => (
                        <div
                          key={link.link + link.title}
                          style={{ padding: "3px" }}
                        >
                          <Link passHref href={link.link}>
                            <Button active={router.asPath.includes(link.link)}>
                              {link.title}
                            </Button>
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div
                  key={`${accordion_id}-link-${index}`}
                  style={{ padding: "8px" }}
                >
                  <Link passHref href={link.link}>
                    <a
                      target={!link.relative ? "_blank" : "_self"}
                      rel={!link.relative ? "noopener noreferrer" : undefined}
                    >
                      <Button active={router.asPath.includes(link.link)}>
                        {link.title}
                      </Button>
                    </a>
                  </Link>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

const MobileSidebar: React.FC<Props> = (props) => {
  const router = useRouter();

  return (
    <div className={styles.sidebar}>
      <div className={styles.body}>
        {props.menu?.map((button, index) =>
          button.type === "link" ? (
            <Link key={index} passHref href={button.link}>
              <div
                className={
                  styles.menulink +
                  (router.pathname === button.link
                    ? " " + styles.activemenulink
                    : "")
                }
              >
                <div className={styles.menulinktitle}>
                  <div className={styles.menulinkicon}>
                    <img
                      className={styles.arrow}
                      src={"/public-new/navigation/" + button.icon + ".svg"}
                      alt=""
                    />
                  </div>
                  <div>{button.title}</div>
                </div>
              </div>
            </Link>
          ) : (
            <Accordion
              accordion_id={`accordion-${index}`}
              key={index}
              data={button}
            />
          )
        )}
      </div>
      <div className={styles.bottommenu}>
        <div className={styles.logout} onClick={async () => await onSignOut()}>
          <img alt="Log out" src={"/public-new/logout.svg"} />
          <div>Logout</div>
        </div>
      </div>
    </div>
  );
};

export default MobileSidebar;
